import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ProfileBaseComponent } from '@luggagehero/features/user';

@Component({
  selector: 'lh-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProfileComponent extends ProfileBaseComponent implements OnInit {}
